import { render, staticRenderFns } from "./BulkActionv2.vue?vue&type=template&id=e4086d28&scoped=true&lang=pug"
import script from "./BulkActionv2.vue?vue&type=script&lang=js"
export * from "./BulkActionv2.vue?vue&type=script&lang=js"
import style0 from "./BulkActionv2.vue?vue&type=style&index=0&id=e4086d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4086d28",
  null
  
)

export default component.exports